import axios from "../../../config/axiosConfig";

// POST /api/chatbot?stream=0
export const chatbotSendMessage = ({ prompt, conversationId = null } = {}) =>
  axios.post("/api/chatbot?stream=0", {
    prompt,
    conversationId,
  });